import React from 'react'

export const TitleAboveTable = ({title, h = "h4"}) => (
  <div className="mt-3 p-2 custom-title">
     <span className={h}>{title}</span>
  </div>
)

